<template>
  <div class="container-fluid">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <PermissionMatrix @role-permissions="updatePermissions" />
  </div>
</template>

<script>
import PermissionMatrix from "../../components/PermissionMatrix.vue";
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";

export default {
  name: "UserPermission",
  data() {
    return {
      permissions: {},
      isLoading: false,
      fullPage: true,
    };
  },
  components: {
    PermissionMatrix,
    Loading,
  },
  methods: {
    ...mapActions(["updateRolePerm", "getRolePerm", "getRoles"]),
    updatePermissions(permissions, role) {
      this.isLoading = true;
      if (role === "Admin") return;
      const roleParam = role.toLowerCase();
      this.permissions = permissions;
      this.updateRolePerm({
        modulePermissions: {
          modulePermissions: permissions[role],
        },
        role: roleParam,
      }).then(() => {
        this.getRolePerm(roleParam).then(() => {
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        });
      }).catch(() => {
        this.isLoading = false;
      });
    },
  },
  // mounted() {
  //   this.getRoles().then(() => {
  //     this.getRolePerm("admin");
  //     this.isLoading = false;
  //   });
  // },
};
</script>

<style></style>
